export enum Gender {
  Homme = 'Homme',
  Femme = 'Femme',
}

export enum OutfitType {
  Haut = 'Haut',
  Bas = 'Bas',
  Robe = 'Robe',
  Jupe = 'Jupe',
  Manteau = 'Manteau',
  Gilet = 'Gilet',
  Combinaison = 'Combinaison',
  Kaftan = 'Kaftan / Boubou',
  Corset = 'Corset / Bustier',
  Complet = 'Complet',
  Traditionnel = 'Tenue Traditionnelle',
}

export type OrderStatus = 'pending' | 'in_progress' | 'ready' | 'delivered' | 'cancelled';

export interface Order {
  id: string;
  clientId: string;
  measurementId?: string | null; // Lien vers la mesure spécifique
  title: string;
  status: OrderStatus;
  outfitType?: OutfitType | null;
  negotiatedAmount?: number | null;
  paid: boolean;
  dueDate?: string | null;
  deliveredAt?: string | null;
  notes?: string | null;
  attachments?: string[];
  createdAt?: string;
  updatedAt: string;
  isDeleted?: boolean;
}

export interface OrderDraft {
  id?: string;
  measurementId?: string | null;
  title: string;
  status: OrderStatus;
  outfitType?: OutfitType | null;
  negotiatedAmount?: number | null;
  paid: boolean;
  dueDate?: string | null;
  deliveredAt?: string | null;
  notes?: string | null;
  attachments?: string[];
}

export interface Measurement {
  id: string;
  outfitType: OutfitType;
  date: string;
  updatedAt: string;
  notes?: string;
  isDeleted?: boolean;
  attachments?: string[];
  orderData?: { amount: number; dueDate: string; paid: boolean };
  [key: string]: string | number | boolean | undefined | string[] | { amount?: number; dueDate?: string; paid?: boolean };
}

export interface Client {
  id: string;
  name: string;
  gender: Gender;
  updatedAt: string;
  contact?: string;
  isDeleted?: boolean;
  measurements: Measurement[];
  images?: string[];
}

export type SubscriptionStatus = 'free' | 'active' | 'expired';

export type SubscriptionPlan = 'free' | 'starter' | 'essentiel' | 'pro' | 'premium' | null | undefined;

export interface SubscriptionInfo {
  client_count: number;
  subscription_status: SubscriptionStatus;
  active_until: string | null;
  plan?: SubscriptionPlan;
  storage_used_mb?: number;
  storage_quota_mb?: number;
}

export interface WorkshopProfile {
  name?: string | null;
  phone?: string | null;
  address?: string | null;
  slogan?: string | null;
  logo_url?: string | null;
}

export interface UserAccount {
  userId: string;
  full_name?: string | null;
  phone?: string | null;
  email?: string | null;
  subscription: SubscriptionInfo;
  workshop?: WorkshopProfile;
}

export interface AuthResponse {
  token: string;
  user: UserAccount;
}

export interface ClientDraft {
  id?: string;
  name: string;
  gender: Gender;
  contact?: string;
}

export interface MeasurementDraft {
  id?: string;
  outfitType: OutfitType;
  notes?: string;
  date?: string;
  attachments?: string[];
  orderData?: {
    amount: number;
    dueDate: string;
    paid: boolean;
  };
  [key: string]: string | number | boolean | undefined | string[] | { amount: number; dueDate: string; paid: boolean };
}

export interface SyncMeta {
  lastSyncAt: string | null;
  lastAttemptAt: string | null;
}

export interface SyncMeasurementPayload {
  id: string;
  clientId: string;
  outfitType: string | null;
  date: string | null;
  notes: string | null;
  values: Record<string, string | number | boolean | string[]>;
  attachments: string[];
  updatedAt: string;
  isDeleted: boolean;
}

export interface SyncOrderPayload {
  id: string;
  clientId: string;
  measurementId: string | null;
  title: string;
  status: string;
  outfitType: string | null;
  negotiatedAmount: number | null;
  paid: boolean;
  dueDate: string | null;
  deliveredAt: string | null;
  notes: string | null;
  attachments: string[];
  updatedAt: string;
  isDeleted: boolean;
}

export interface SyncClientPayload {
  id: string;
  name: string | null;
  gender: string | null;
  contact: string | null;
  images?: string[];
  updatedAt: string;
  isDeleted: boolean;
  measurements: SyncMeasurementPayload[];
}
